<template>
    <div
        v-if="order"
        ref="customerModal"
        id="viewCustomer" 
        class="modal fade" 
        aria-hidden="true" 
        tabindex="-1" 
        data-backdrop="static" 
        data-keyboard="false"
    >
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content bg-white">
                <div class="modal-header">
                    <h5 class="modal-title">Customer Details</h5>
                    <!-- <button type="button" class="btn-close" @click="hideModal"></button> -->
                </div>
                <div class="modal-body g-3">
                    <template v-if="order.customer.account_type === 'business'" class="row mb-3">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label ">Agency Name <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">{{ order?.customer?.name }}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label ">Agency Phone <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order?.customer?.phone_number }}
                                <span @click="copyToClipboard(order?.customer?.phone_number)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div v-if="order?.customer?.cp_name && order.customer.cp_name!=''" class="row">
                            <div class="col-lg-3 col-md-4 label">Customer Name <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order.customer.cp_name }}
                                <span @click="copyToClipboard(order.customer.cp_name)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div v-else-if="order?.address_contact_person?.first_name && order.address_contact_person.first_name!=''" class="row">
                            <div class="col-lg-3 col-md-4 label">Customer Name <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order.address_contact_person.first_name }} {{ order.address_contact_person.last_name }}
                                <span @click="copyToClipboard(order.address_contact_person.first_name)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div v-if="order?.customer?.cp_phone && order.customer.cp_phone!=''" class="row">
                            <div class="col-lg-3 col-md-4 label">Customer Phone <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order.customer.cp_phone }}
                                <span @click="copyToClipboard(order.customer.cp_phone)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div v-if="order?.address_contact_person?.phone_number && order?.address_contact_person?.phone_number !=''" class="row">
                            <div class="col-lg-3 col-md-4 label">Customer Phone <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order?.address_contact_person?.phone_number }}
                                <span @click="copyToClipboard(order?.address_contact_person?.phone_number)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="order.customer.name!=''" class="row">
                            <div class="col-lg-3 col-md-4 label">Customer Name <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order.customer.name }}
                                <span @click="copyToClipboard(order.customer.name)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div v-if="order?.customer?.phone_number!=''" class="row">
                            <div class="col-lg-3 col-md-4 label">Customer Phone <span class="float-end">:</span></div>
                            <div class="col-lg-9 col-md-8">
                                {{ order?.customer?.phone_number }}
                                <span @click="copyToClipboard(order?.customer?.phone_number)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                    </template>
                    
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Customer Email <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">
                            {{ order.customer.email }}
                            <span @click="copyToClipboard(order.customer.email)" class="cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Service Address <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">
                            <template v-if="order.service_address">
                                {{ order.service_address }}
                                <span @click="copyToClipboard(order.service_address)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </template>
                            <template v-else-if="order?.address?.full_address">
                                {{ order.address.full_address }}
                                <span @click="copyToClipboard(order.address.full_address)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </template>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Postal Code <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">
                            <template v-if="order.postal_code">
                                {{ order.postal_code }}
                                <span @click="copyToClipboard(order.postal_code)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </template>
                            <template v-else-if="order?.address?.postal_code">
                                {{ order.address.postal_code }}
                                <span @click="copyToClipboard(order.address.postal_code)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </template>
                            <template v-else>
                                N/A
                            </template>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Services <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8" v-html="order.services.map(service => (service.service_name || service.name)).join('<br/>')">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Price <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">{{ userCurrency +  (order?.price || order?.total_amount || 0) }}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Service Date <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">{{ momentObj(order?.service_date || order?.booking_date).format('DD MMM YYYY') }}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Service Time <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">{{ momentObj(order?.service_date || order?.booking_date).format('hh:mm A') }} - {{ momentObj(order?.service_date || order?.booking_date).add(order?.service_duration || order?.booking_duration, 'hours').format('hh:mm A') }}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Access Arrangement <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">{{ order.access_arrangement || 'N/A' }}</div>
                    </div>
                    <div v-if="order?.customer?.notes" class="row">
                        <div class="col-lg-3 col-md-4 label">Customer Notes <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">{{ order?.customer?.notes }}</div>
                    </div>
                    <div v-if="order?.address?.notes" class="row">
                        <div class="col-lg-3 col-md-4 label">Address Notes <span class="float-end">:</span></div>
                        <div class="col-lg-9 col-md-8">{{ order?.address?.notes }}</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-danger" @click="hideModal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { appMixin } from "../../mixin/appMixin";

export default {
    name: "CustomerDetails",
    mixins: [appMixin],
    props: {
        order: {
            type: Object,
            default: () => ({
                customer: {
                    account_type: 'individual',
                    name: '',
                    phone_number: '',
                    email: '',
                    cp_name: '',
                    cp_type: '',
                    cp_phone_number: '',
                    customer_name: '',
                    customer_phone: '',
                },
                address: {
                    id: '',
                    address: '',
                    postal_code: '',
                    full_address: '',
                    notes: '',
                },
                services: [],
                service_address: '',
                postal_code: '',
                price: 0,
                service_date: '',
                service_time: '',
            })
        }
    },
    methods: {
        showModal() {
            $('#viewCustomer').modal('show');
        },
        hideModal() {
            $('#viewCustomer').modal('hide');

            // Emit an event to close the modal
            this.$emitter.emit('reset-selected-order');
        }
    }
}
</script>
